import type { CarePlanTagDetail } from "@/types/care-plan-template";

import { requestData } from "@/api/api-config";

const basePath = "admin/care-plan-tags";

async function listCarePlanTags(): Promise<CarePlanTagDetail[] | null> {
  return await requestData<CarePlanTagDetail[]>(basePath, "get");
}

async function createCarePlanTag(data: {
  name: string;
  color?: string;
}): Promise<CarePlanTagDetail | null> {
  return await requestData<CarePlanTagDetail>(basePath, "post", { json: data });
}

async function updateCarePlanTag(
  id: string,
  data: { name?: string; color?: string },
): Promise<CarePlanTagDetail | null> {
  return await requestData<CarePlanTagDetail>(`${basePath}/${id}`, "put", {
    json: data,
  });
}

async function deleteCarePlanTag(id: string): Promise<boolean | null> {
  return await requestData<boolean>(
    `${basePath}/${id}`,
    "delete",
    undefined,
    false,
  );
}

export const carePlanTagApi = {
  list: listCarePlanTags,
  create: createCarePlanTag,
  update: updateCarePlanTag,
  delete: deleteCarePlanTag,
};
